export type Platform = 'youtube' | 'instagram' | 'tiktok';

export interface AnalyticsEntry {
  id: string;
  platform: Platform;
  contentName: string;
  views: number;
  likes: number;
  comments: number;
  engagementRate: number;
  screenshot?: File | null;
  screenshotPreview?: string;
  date: string;
  previousEntry?: {
    views: number;
    likes: number;
    comments: number;
    engagementRate: number;
  };
}

export interface AnalyticsInsight {
  type: 'success' | 'info' | 'warning';
  message: string;
  metric?: string;
  improvement?: number;
}

export interface MetricTooltip {
  label: string;
  description: string;
}

export const METRIC_TOOLTIPS: Record<string, MetricTooltip> = {
  views: {
    label: 'Visualizações',
    description: 'Número total de vezes que seu conteúdo foi visualizado'
  },
  likes: {
    label: 'Curtidas',
    description: 'Número de pessoas que curtiram seu conteúdo'
  },
  comments: {
    label: 'Comentários',
    description: 'Número de comentários recebidos no seu conteúdo'
  },
  engagementRate: {
    label: 'Taxa de Engajamento',
    description: 'Porcentagem de pessoas que interagiram com seu conteúdo (likes + comentários ÷ views × 100)'
  },
  screenshot: {
    label: 'Screenshot',
    description: 'Capture uma imagem dos analytics da sua plataforma para referência futura e comparação'
  }
};